import {IntermediatePart} from "../../intermediatePart";

export default class Hood extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = 'hood';
    this.partName = 'Hood';
    this.translateId = "visualizer.kitchen.appliance.hood";
    this.canBeDisabled = true;
  }

  load(dbFeature) {
    return super.load_(dbFeature, new Hood());
  }

  // add dependency on stove width, if width is 24 - we need width 30, if stove is 60 - we need 48

  disabledClick() {
    const applianceParent = this.getParent();
    const stove = applianceParent.stove;
    if (stove && !this.disabled && stove.disabled) {
      stove.disabled = false;
    }
    if ((applianceParent.layout.type === 6) && !this.disabled && applianceParent.microwave
      && !applianceParent.microwave.disabled) {
      applianceParent.microwave.disabled = true;
    }
  }

}
